import React from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HireTalent from "../pages/hire-talent/page";
import ApplyTalent from "../pages/apply-talent/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hire-talent",
    element: <HireTalent />,
  },
  {
    path: "/apply-talent",
    element: <ApplyTalent />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
